import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCreateContractor, ApiDeleteContractor, ApiGetContractorById, ApiUpdateContractor } from "utils/constants/api";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";

export default function ContractorForm(){
    let navigate = useNavigate()

    const{ fetch: createContractor } = useFetch(ApiCreateContractor)
    const{ fetch: updateContractor } = useFetch(ApiUpdateContractor)
    const{ fetch: deleteContractor } = useFetch(ApiDeleteContractor)
    const{ fetch: getContractorById } = useFetch(ApiGetContractorById)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramContractorId = queryString.get("contractorId")

    const [contractorId, setContractorId] = useState(EmptyString)
    const [contractorName, setContractorName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [bankName2, setBankName2] = useState(EmptyString)
    const [accountNumber, setAccountNumber] = useState(EmptyString)
    const [accountNumber2, setAccountNumber2] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errContractorId, setErrContractorId] = useState(false)
    const [errContractorName, setErrContractorName] = useState(false)
    const [errAddress, setErrAddress] = useState(false)
    const [errBankName, setErrBankName] = useState(false)
    const [errAccountNumber, setErrAccountNumber] = useState(false)

    const contractorNameChange = (e) => { setContractorName(e.target.value) }
    const addressChange = (e) => { setAddress(e.target.value) }
    const bankNameChange = (e) => { setBankName(e.target.value) }
    const bankName2Change = (e) => { setBankName2(e.target.value) }
    const accountNumberChange = (e) => { setAccountNumber(e.target.value) }
    const accountNumber2Change = (e) => { setAccountNumber2(e.target.value) }

    const saveBtnClick = () => {
        if (fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fCreateContractor().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateContractor().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteContractor(paramContractorId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        //window.location.href = "/contractor-setting"
        navigate("/contractor-setting")
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        if(formType === FormTypeEdit){
            setLoading({isOpen: true})
            
            fGetContractor(paramContractorId).then(() => {
                setLoading({isOpen: false})
            })
        }
    }, [])

    // Function Api Call
    async function fCreateContractor(){
        await createContractor({
            data: {
                contractorName: contractorName,
                address: address,
                bankName: bankName,
                bankName2: bankName2,
                accountNumber: accountNumber,
                accountNumber2: accountNumber2
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/contractor-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateContractor(){ 
        await updateContractor({
            data: {
                contractorId: contractorId,
                contractorName: contractorName,
                address: address,
                bankName: bankName,
                bankName2: bankName2,
                accountNumber: accountNumber,
                accountNumber2: accountNumber2
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/contractor-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetContractor(paramContractorId){
        await getContractorById({
            data: {
                contractorId: String(paramContractorId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                setContractorId(data.contractorId)
                setContractorName(data.contractorName)
                setAddress(data.address)
                setBankName(data.bankName)
                setBankName2(data.bankName2)
                setAccountNumber(data.accountNumber)
                setAccountNumber2(data.accountNumber2)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }  
    async function fDeleteContractor(paramContractorId, status){
        await deleteContractor({
            data: {
                contractorId: paramContractorId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/contractor-setting")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (formType === FormTypeEdit){
            if (contractorId === null || contractorId === EmptyString){
                errorCount++
                setErrContractorId(true)
            }else{
                setErrContractorId(false)
            }
        }
        
        if (contractorName === null || contractorName === EmptyString){
            errorCount++
            setErrContractorName(true)
        }else{
            setErrContractorName(false)
        }
        if (address === null || address === EmptyString){
            errorCount++
            setErrAddress(true)
        }else{
            setErrAddress(false)
        }
        if (bankName === null || bankName === EmptyString){
            errorCount++
            setErrBankName(true)
        }else{
            setErrBankName(false)
        }
        if (accountNumber === null || accountNumber === EmptyString){
            errorCount++
            setErrAccountNumber(true)
        }else{
            setErrAccountNumber(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Contractor Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Contractor Id */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Contractor Id</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={contractorId} disabled={true} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errContractorId ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Contractor Id is required!</span>
                    </div>
                </div>

                {/* Contractor Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Contractor Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={contractorName} onChange={contractorNameChange} maxLength={30} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errContractorName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Contractor Name is required!</span>
                    </div>
                </div>

                {/* Address */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-start">
                        <div className="w-48 pt-2">
                            <span>Address</span>
                        </div>
                        <div className="px-4 pt-2 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <textarea className="input" value={address} onChange={addressChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errAddress ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Address is required!</span>
                    </div>
                </div>

                {/* Bank Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ bankName } onChange={bankNameChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errBankName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Name is required!</span>
                    </div>
                </div>

                {/* Account Number */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Account Number</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ accountNumber } onChange={accountNumberChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errAccountNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Account Number is required!</span>
                    </div>
                </div>

                {/* Bank Name 2*/}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Name 2</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ bankName2 } onChange={bankName2Change} maxLength={20} />
                        </div>
                    </div>
                </div>
                
                {/* Account Number */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Account Number 2</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ accountNumber2 } onChange={accountNumber2Change} maxLength={20} />
                        </div>
                    </div>
                    {/* <div className={`flex flex-wrap items-center ${ errAccountNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Account Number is required!</span>
                    </div> */}
                </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />                
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}